import { AnyAction, createListenerMiddleware, ListenerEffectAPI, ThunkDispatch } from "@reduxjs/toolkit";
import _ from "lodash";
import { TaxReduxDispatch, TaxReduxState } from "./general/reduxStore";
import { bulkSaveJsonPreferences, findPreferences } from "../backend/taxguru/client/jmf/corePreferencesClient";
import { ApplicationSettingsState, initState } from "./applicationSettingsSlice";

export const applicationSettingsStateUpdateReduxListenerInstance = createListenerMiddleware();

const TAX_APP_SETTINGS_KEY = "TAX-APP-SETTINGS";
const persistTaxAppSettings = _.debounce(async function (api: ListenerEffectAPI<unknown, ThunkDispatch<unknown, unknown, AnyAction>>) {
    const state: TaxReduxState = api.getState() as TaxReduxState;
    if (!state.user.userId) {
        console.warn("Empty user ID when persisting table states");
        return;
    }
    const taxSettingsState = state.taxSettings;
    const jsonValues: Array<[string, object]> = [[TAX_APP_SETTINGS_KEY, taxSettingsState]];
    await bulkSaveJsonPreferences(jsonValues, state.user.userId);
}, 2000);

applicationSettingsStateUpdateReduxListenerInstance.startListening({
    predicate: (action) => action.type.toString().startsWith("taxAppSettings"),
    effect: (action, api) => persistTaxAppSettings(api),
});

export function initialiseAppSettingsThunk(userId: string) {
    return async (dispatch: TaxReduxDispatch) => {
        try {
            const response = await findPreferences([TAX_APP_SETTINGS_KEY], userId);
            if (response.data.data && response.data.data.length === 1) {
                const { jsonValue } = response.data.data[0];
                if (jsonValue) {
                    const parsed = JSON.parse(jsonValue) as ApplicationSettingsState;
                    dispatch(initState(parsed));
                }
            }
        } catch (err) {
            console.error("Error initialising dialog positions", err);
        }
    };
}